module.exports = __WEBPACK_EXTERNAL_MODULE_aws_sdk_global__;